/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Export_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to export audit logs. Please try again." |
*
* @param {Audit_Export_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_export_error = /** @type {((inputs?: Audit_Export_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Export_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Export der Audit-Logs fehlgeschlagen. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to export audit logs. Please try again.")
});